// extracted by mini-css-extract-plugin
export default {"card":"check-conf-modal_card__vd9ts"};